import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
  PaginationProps
} from '@/components/ui/Pagination';
import { cn } from '@/lib/helpers/utils';
import { DOTS, usePagination } from '@/lib/hooks';
import React from 'react';

export interface PaginationControlsProps extends PaginationProps {
  onPageChange?: (page: number) => void;
  totalCount: number;
  siblingCount?: number;
  currentPage?: number;
  pageSize: number;
}

const PaginationControls = ({
  onPageChange,
  totalCount,
  siblingCount = 1,
  currentPage = 1,
  pageSize,
  className,
  ...props
}: PaginationControlsProps) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });

  if (!paginationRange || currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange && (onPageChange as any)(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange && (onPageChange as any)(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];

  return (
    <Pagination className={cn('', className)} {...props}>
      <PaginationContent className="justify-center md:justify-start">
        <PaginationItem>
          <PaginationPrevious disabled={currentPage === 1} onClick={onPrevious} />
        </PaginationItem>
        {paginationRange.map((pageNumber: number | string, index: number) => {
          if (pageNumber === DOTS) {
            return <PaginationEllipsis key={index} className="hidden md:flex" />;
          }

          return (
            <PaginationItem key={index} className="hidden md:block">
              <PaginationLink
                isActive={pageNumber === currentPage}
                onClick={() => (onPageChange as any)(pageNumber as number)}
              >
                {pageNumber}
              </PaginationLink>
            </PaginationItem>
          );
        })}
        <PaginationItem>
          <PaginationNext disabled={currentPage === lastPage} onClick={onNext} />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
};

export default PaginationControls;
